import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import { AFFIRM_SHOP_URL, CHECKOUT_PAYMENT } from "@/constants/index"

export const addAnalyticsForCardPayment = () => {
  const eventInfo = {
    eventAction: "checkout:payment & billing:checkout with card",
    eventName: "checkout:payment & billing:checkout with card",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "pay with credit card",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addAnalyticsForCcfailure = (
  status,
  message,
  paymentOption,
  i18n
) => {
  // handle Requirement#19 Sticky Nav Add To Cart
  const eventInfo = {
    eventAction: "checkout:payment & billing:next",
    eventName: "checkout:payment & billing:next",
    eventType: "navigation",
    eventMsg:
      status === "success"
        ? "payment success"
        : message
        ? message.toLowerCase()
        : i18n?.paymentFailed?.toLowerCase(),
    eventStatus: status,
    internalLinkName: "review your order",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:payment method:" + paymentOption,
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addAnalyticsForPaypal = () => {
  const eventInfo = {
    eventAction: "checkout:payment & billing:checkout with paypal",
    eventName: "checkout:payment & billing:checkout with paypal",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "pay with paypal",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addAnalyticsForPaypalButton = () => {
  const eventInfo = {
    eventAction: "checkout:payment & billing:paypal payments",
    eventName: "checkout:payment & billing:paypal payments",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "paypal",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: "n/a",
    clickInternalLinks: "false",
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addAnalyticsForAffirmPayment = () => {
  const eventInfo = {
    eventAction: "checkout:payment & billing:pay over time with affirm",
    eventName: "checkout:payment & billing:pay over time with affirm",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "pay over time with affirm",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addAnalyticsForAffirmPaymentButton = type => {
  const learnMore = type === "learn more"
  const eventAction = `checkout:payment & billing:${
    learnMore
      ? "pay over time with affirm:learn more"
      : "affirm monthly payments"
  }`
  const eventInfo = {
    eventAction,
    eventName: eventAction,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${learnMore ? "learn more" : "affirm monthly payments"}`,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: AFFIRM_SHOP_URL,
    clickInternalLinks: `${learnMore ? "true" : "false"}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addAnalyticsForErrorInReviewYourOrder = paymentErrorMessage => {
  const eventInfo = {
    eventAction: "checkout:payment & billing:next",
    eventName: "checkout:payment & billing:next",
    eventType: "navigation",
    eventMsg: paymentErrorMessage,
    eventStatus: "failure",
    internalLinkName: "review you order",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:payment method:card",
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addAnalyticsForErrorMessages = (
  eventMsg = "n/a",
  eventStatus = "n/a",
  isModalOpen = false,
  eventText = "place order",
  modalCloseText = ""
) => {
  const extraText = isModalOpen ? ":modal:something went wrong" : ""
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `checkout:review${extraText}${modalCloseText}:${eventText}`,
    eventMsg,
    eventName: `checkout:review${extraText}${modalCloseText}:${eventText}`,
    eventStatus,
    eventType: "navigation",
    internalLinkName: `${eventText}`,
    internalLinkPosition: `checkout${extraText}`,
    internalLinkType: "checkout:navigation",
    internalLinkURL: "n/a",
    internalLinkZoneName: `checkout:review${extraText}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsForErrorCheckout = (
  event,
  customerCareNum = "n/a",
  paymentOption = "",
  eventMsg = "n/a",
  eventStatus = "n/a",
  eventText = "checkout:review"
) => {
  event.preventDefault()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${eventText}:${customerCareNum}`,
    eventMsg,
    eventName: `${eventText}:${customerCareNum}`,
    eventStatus,
    eventType: "navigation",
    internalLinkName: customerCareNum,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkURL: event.target.href,
    internalLinkZoneName: eventText,
  }

  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsForErrorCheckoutCard = (
  event,
  customerCareNum = "n/a",
  paymentOption = "",
  eventMsg = "n/a",
  eventStatus = "n/a",
  eventText = "checkout"
) => {
  event.preventDefault()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${eventText}:${CHECKOUT_PAYMENT}:${customerCareNum}`,
    eventMsg,
    eventName: `${eventText}:${CHECKOUT_PAYMENT}:${customerCareNum}`,
    eventStatus,
    eventType: "navigation",
    internalLinkName: customerCareNum,
    internalLinkPosition: eventText,
    internalLinkType: `${eventText}:payment method:${paymentOption}`,
    internalLinkURL: event.target.href,
    internalLinkZoneName: `${eventText}:${CHECKOUT_PAYMENT}`,
  }

  pushAnalyticsObjToDataLayer(eventInfo)
}
